import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import { GetAuthTokenResponse, StartSessionInput, StartSessionResponse } from './sso-interface';

export const startSession = async (input: StartSessionInput): Promise<StartSessionResponse> => {
  const data = await API.post(API_SERVICES.SSO_API, `/open/session`, {
    headers: {
      'Content-Type': 'application/json',
    },
    data: input,
  });

  return data.data;
};

export const getAuthToken = async (): Promise<GetAuthTokenResponse> => {
  const data = await API.get(API_SERVICES.SSO_API, `/token`, {
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  return data.data;
};
